import React from 'react';
import { Home, FileText, LogOut, PieChart, StickyNote } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Sidebar() {
  const location = useLocation();
  const path = location.pathname;
  const { logout, user } = useAuth();

  const isActive = (route) => {
    if (route === '/') return path === '/';
    return path.startsWith(route);
  };

  const navItems = [
    { to: '/', icon: Home, label: 'Dashboard', check: '/' },
    { to: '/months', icon: FileText, label: 'All Months', check: '/month' },
    { to: '/sticky-board', icon: StickyNote, label: 'Sticky Board', check: '/sticky-board' },
    { to: '/reports', icon: PieChart, label: 'Reports', check: '/reports' },
  ];

  return (
    <aside className="hidden md:flex w-52 bg-white border-r border-gray-100 h-full min-h-[calc(100vh-60px)] flex-col shadow-sm">
      <nav className="flex-1 py-4 px-3 overflow-y-auto">
        <ul className="space-y-1">
          {navItems.map(({ to, icon: Icon, label, check }) => {
            const active = isActive(check);
            return (
              <li key={to}>
                <Link
                  to={to}
                  className={`flex items-center gap-3 px-4 py-2.5 rounded-2xl font-medium text-sm transition-all ${
                    active
                      ? 'bg-blue-50 text-blue-700'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  }`}
                >
                  <Icon className={`w-4 h-4 shrink-0 ${active ? 'text-blue-600' : 'text-gray-400'}`} />
                  {label}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Bottom profile + logout section */}
      <div className="px-3 py-4 border-t border-gray-100">
        {user?.phone && (
          <div className="flex items-center gap-2.5 px-3 py-2 mb-2">
            <div className="w-7 h-7 rounded-full bg-blue-100 flex items-center justify-center shrink-0">
              <span className="text-xs font-bold text-blue-600">
                {user.phone.charAt(0).toUpperCase()}
              </span>
            </div>
            <span className="text-xs font-medium text-gray-600 truncate">{user.phone}</span>
          </div>
        )}
        <button
          onClick={logout}
          className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-600 hover:bg-red-50 hover:text-red-600 rounded-2xl font-medium transition-all"
        >
          <LogOut className="w-4 h-4 shrink-0 text-gray-400" />
          Logout
        </button>
      </div>
    </aside>
  );
}
